import type { CalculateRegistryPurchaseInfoFragmentFragment } from '@graphql/generated';

// also @see:  SalesOrderLineFragment
//   `shippingAndHandling` is a typical Cost Line Array "bucket"
export type AdditionalCostLine = Pick<CalculateRegistryPurchaseInfoFragmentFragment['shippingAndHandling'][0], 'lineValue' | 'title'> & { __typename: string };
type AdditionalCostLineBuckets = {
  shippingAndHandling: AdditionalCostLine[];
  orderCharges: AdditionalCostLine[];
  postPurchaseFees: AdditionalCostLine[];
  compensation: AdditionalCostLine[];
};

export const additionalCostLinesInDisplayOrder = (
  calculateRegistryPurchaseInfo: Maybe<AdditionalCostLineBuckets>,
  options: {
    // Shipping is sometimes a special case, not "just another cost line"
    includeShipping?: boolean;
  } = {},
): AdditionalCostLine[] => {
  return [
    ...((options.includeShipping && calculateRegistryPurchaseInfo?.shippingAndHandling) || []),
    ...(calculateRegistryPurchaseInfo?.orderCharges ?? []),
    ...(calculateRegistryPurchaseInfo?.postPurchaseFees ?? []),
    ...(calculateRegistryPurchaseInfo?.compensation ?? []),
  ];
};
